import { Request, Setting } from '../index';
import apiUser from './apiUser';
import { sleep } from '@yichui/js-contrib/src/utils';

let isDoing = false; // 防并发
let cacheToken = {}; // 用户token对象
let cacheSession = null; // 检查session有效性的定时任务

//
function getVal(item, objPath, defaultVal) {
  let ret;
  try {
    ret = objPath.split('.').reduce(function (object, property) {
      return object[property];
    }, item);
  } catch (e) {
    ret = defaultVal;
  }
  return ret === undefined ? (defaultVal === undefined ? '' : defaultVal) : ret;
}

// 检查微信会话合法性
let cacheCheckWxSession = undefined;
function checkWxSession() {
  console.log('[wx-session] check begin', cacheCheckWxSession);
  return new Promise((resolve, reject) => {
    if (cacheCheckWxSession === true) {
      console.log('[wx-session] cache avaibale');
      resolve(cacheCheckWxSession);
      return;
    }
    if (!wx) {
      reject(false);
      return;
    }
    const start = new Date();
    wx.checkSession({
      success() {
        // session_key 未过期，并且在本生命周期一直有效
        console.log('[wx-session] check avaible', (new Date().getTime() - start.getTime()) / 1000);
        cacheCheckWxSession = true;
        resolve(true);
      },
      fail() {
        // session_key 已经失效，需要重新执行登录流程
        console.log('[wx-session] check expire', (new Date().getTime() - start.getTime()) / 1000);
        cacheCheckWxSession = false;
        reject(false);
        // resolve(false);
      },
    });
  });
}

// 确保已得到授权信息 isForce:true 重新登录
const getAuthSync = async (isForce = false) => {
  if (wx && !isForce) {
    // 确保微信sessionKey有效:设置定时器
    if (!cacheSession) {
      const checkSession = async () => {
        // eslint-disable-next-line no-unused-vars
        const isValid = await checkWxSession();
        console.log(`[debug-async] checkWxSession`, isValid);
        if (!isValid) {
          // 重新登录
          await getAuthSync(true).catch(err => err);
          console.log(`[debug-async] getAuthSync`);
          cacheSession = new Date();
        }
        return isValid;
      };
      cacheSession = setInterval(checkSession, 1000 * 60 * 5); // 暂定每5分钟一次
      await checkSession().catch(err => err); // 马上执行一次
      console.log(`[debug-async] checkSession`);
    }
  }
  // console.log('getAuthSync', isForce);
  //
  console.log('[debug] getAuthSync begin');
  const ret = await getTokenSync(isForce);
  console.log('[debug] getAuthSync done');
  return ret;
};

// 确保能获取uid
// const getUidSync = async (isForce = false) => {
//   await getTokenSync(isForce);
//   return cacheUid;
// };

// 确保能获取用户 isForce:true 不读缓存
// eslint-disable-next-line no-unused-vars
const getTokenSync = async (isForce = false) => {
  console.log('[debug] getTokenSync begin');
  if (cacheToken && cacheToken.token && !isForce) {
    // 已登录:读缓存
    return cacheToken;
  } else {
    isForce = true;
  }

  // 防并发
  if (isDoing) {
    // 等待上一个请求的结果
    while (isDoing) {
      console.log('doing wait...');
      await sleep(100);
      console.log(`[debug-async] sleep`);
    }
  } else {
    // 开始任务
    try {
      isDoing = true;

      // 若本地存有token,验证缓存token是否还有效或更新token
      if (isForce && Request.getToken()) {
        // 验证微信session
        let isWxValid = cacheCheckWxSession;
        if (!isWxValid) {
          console.log('[debug] getTokenSync-checkWxSession begin');
          isWxValid = await checkWxSession();
          console.log('[debug] getTokenSync-checkWxSession done');
        }
        // 验证系统token
        if (isWxValid) {
          // session合法:验证token
          console.log('[debug] getTokenSync-statusUser begin');
          const res = await apiUser.statusUser({}).catch(err => err);
          console.log('[debug] getTokenSync-statusUser done');
          if (res) {
            // token有效且已刷新
            cacheToken = res;
            isForce = false;
          }
        }
      }

      // 重新登录
      if (isForce) {
        cacheToken = {};
        uni.showLoading({
          title: '加载中',
          mask: true,
        });
        // 微信登录
        const code = await getWxMiniAppCode();
        console.log(`[debug-async] getWxMiniAppCode`);
        // let code = '';
        // await new Promise((resolve, reject) => {
        //   uni.login({
        //     provider: 'weixin',
        //     success: res => {
        //       // 拿到授权code
        //       if (res && res.code) {
        //         code = res.code;
        //       }
        //       resolve(res);
        //     },
        //     fail: err => {
        //       reject(err);
        //     },
        //   });
        // });
        if (!code) {
          // 取不到微信code
          // uni.hideLoading();
          // uni.showModal({
          //   title: '微信错误',
          //   content: '无法获取微信授权信息',
          //   showCancel: false,
          //   confirmText: '知道了',
          // });
          // 登出
        } else {
          // api登录
          await apiUser
            .loginWithMiniApp({
              form: {
                bindApp: 'wx_miniapp',
                bindKey: Setting.appId,
                bindCode: code,
              },
            })
            .then(res => {
              // console.log('登录成功', res);
              cacheToken = res;
              // cacheUid = getVal(res, 'login.userWithCode.uid');
            })
            .catch(err => {
              console.warn('登录失败', err);
            });
          console.log('登录结束');
        }
      }
      // token获取/更新完毕
    } catch (err) {
      console.log('[err] getTokenSync', err);
    }
    uni.hideLoading();
    isDoing = false;
  }

  // 模块初始化
  // if (cacheToken) {
  //   Setting.doInitialHandlerToken(cacheToken);
  // }

  // ret
  // try {
  //   if (cacheToken && cacheToken.uid) {
  //     // 存store
  //     Request.setValue(Setting.getStoreToken(), cacheToken.token);
  //     Request.setValue(Setting.getStoreUid(), cacheToken.uid);
  //     return cacheToken;
  //   } else {
  //     // 清空token
  //     if (Setting.app && Setting.app.$store) {
  //       Setting.app.$store.dispatch('user/clean');
  //     } else {
  //       Request.delValue(Setting.getStoreToken());
  //       Request.delValue(Setting.getStoreUid());
  //     }
  //     return null;
  //   }
  // } catch (err) {
  //   console.warn('[getTokenSync] store err', err);
  //   return null;
  // }
  console.log('[debug] getTokenSync done');
  const ret = await getResult();
  console.log(`[debug-async] getResult`);
  return ret;
};

// 手机号登录
const getAuthByPhone = async (code, encryptedData, iv) => {
  // api登录
  await apiUser
    .loginWithMiniApp({
      form: {
        bindApp: 'wx_miniapp',
        bindKey: Setting.appId,
        bindCode: code,
        bindVal: encryptedData,
        bindSign: iv,
      },
    })
    .then(res => {
      // console.log('登录成功', res);
      cacheToken = res;
      // cacheUid = getVal(res, 'login.userWithCode.uid');
    });
  // .catch(err => {
  //   console.warn('登录失败', err);
  // });
  //
  const ret = await getResult();
  console.log(`[debug-async] getResult`);
  return ret;
};

//
const getResult = async () => {
  // ret
  try {
    if (cacheToken && cacheToken.uid) {
      // 存store
      Request.setValue(Setting.getStoreToken(), cacheToken.token);
      Request.setValue(Setting.getStoreUid(), cacheToken.uid);
      return cacheToken;
    } else {
      // 清空token
      if (Setting.app && Setting.app.$store) {
        Setting.app.$store.dispatch('user/clean');
      } else {
        Request.delValue(Setting.getStoreToken());
        Request.delValue(Setting.getStoreUid());
      }
      return null;
    }
  } catch (err) {
    console.warn('[getTokenSync] store err', err);
    return null;
  }
};

// 取微信小程序code
const getWxMiniAppCode = async () => {
  // 微信登录
  let code = '';
  await new Promise((resolve, reject) => {
    uni.login({
      provider: 'weixin',
      success: res => {
        // 拿到授权code
        if (res && res.code) {
          code = res.code;
        }
        resolve(res);
      },
      fail: err => {
        reject(err);
      },
    });
  });
  console.log(`[debug-async] Promise`);
  if (!code) {
    // 取不到微信code
    uni.hideLoading();
    uni.showModal({
      title: '微信内部错误',
      content: '无法获取微信授权信息',
      showCancel: false,
      confirmText: '我稍后再试',
    });
  }
  return code;
};

//
export default {
  getAuthSync,
  getAuthByPhone,
  getWxMiniAppCode,
  checkWxSession,
  // getUidSync,
  // getTokenSync,
};
